import src from "IMAGE";
export default { src, width: 360, height: 648, blurWidth: 0, blurHeight: 0};
